<template>
  <div class="animated fadeIn">
    <b-card-body id="areaImprimir">
      <b-row class="border-bottom mb-2">
        <b-col style="margin-right: 10px">
          <b-img
            :src="img"
            left
            fluid
            style="max-height: 100px"
            alt="Responsive image"
            class="rounded pb-0"
          ></b-img>
          <h1 class="text-right">
            Orden de compra #{{ purchaseOrderData.number }}
          </h1>

          <a href="#" class="float-right text-black-50" @click="descargarPDF"
            ><i class="fa fa-download"></i
          ></a>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="mb-3"><strong>Detalles:</strong></h6>
          <div>Proveedor: {{ purchaseOrderData.company }}</div>
          <div>Moneda: {{ purchaseOrderData.currency }}</div>
          <div>
            Fecha del pedido : {{ purchaseOrderData.order_date | moment }}
          </div>
          <div>
            Fecha de entrega: {{ purchaseOrderData.delivery_date | moment }}
          </div>
        </b-col>
      </b-row>
      <h6 class="mb-3 font-weight-bold">Detalle Materiales:</h6>
      <div class="table-responsive-sm">
        <table class="table table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th class="align-middle">Material</th>
              <th class="align-middle">Cantidad</th>
              <th class="align-middle">Precio Unitario</th>
              <th class="align-middle">Precio Total</th>
            </tr>
          </thead>
          <tbody>
            <template>
              <tr v-for="(data, index) in purchaseOrderDetails">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="left align-middle">{{ data.supply }}</td>
                <td class="left align-middle">{{ data.quantity }}</td>
                <td class="left align-middle">{{ data.unit_price }}</td>
                <td class="left align-middle">{{ data.total_price }}</td>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td class="text-right"></td>
              <td class="text-left">TOTALES</td>
              <td class="text-left">{{ totalQuantity }}</td>

              <td class="text-left"></td>
              <td class="text-left">{{ totalTotalPrice }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <b-row class="mt-3" v-if="purchaseOrderData.note != ''">
        <b-col lg="12" sm="12">
          <b>Notas:</b> {{ purchaseOrderData.note }}
        </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import numeral from "numeral";
import locale from "numeral/locales";

numeral.locale("es");

export default {
  name: "Report",
  props: ["purchaseOrderDetails", "purchaseOrderData"],
  data() {
    return {
      img: ""
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    decimal(value) {
      return numeral(value).format("0,0.00");
    }
  },
  computed: {
    totalQuantity() {
      return this.purchaseOrderDetails.reduce(
        (total, item) => total + parseInt(item.quantity),
        0
      );
    },
    totalUnitPrice() {
      return parseFloat(
        this.purchaseOrderDetails.reduce(
          (total, item) => total + parseFloat(item.unit_price),
          0
        )
      ).toFixed(2);
    },
    totalTotalPrice() {
      return parseFloat(
        this.purchaseOrderDetails.reduce(
          (total, item) => total + parseFloat(item.total_price),
          0
        )
      ).toFixed(2);
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");
  },
  methods: {
    moment: function () {
      return moment();
    },
    printDiv() {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.5 },
        filename:
          "Planificación Producción" + this.purchaseOrderData.id + ".pdf",
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>

<style scoped></style>
